import React from 'react';

import styled from '@emotion/styled';
import { mq, green02, green01, fastDurationTime, baseDurationTime, text } from '../../../_style';
import { Link } from 'gatsby';
import Image from '../../atoms/image';

const Container = styled(Link)(props => `
  ${props.current ? 'pointer-events: none; opacity: 0.6;' : ''}
  background-color: #fff;
  display: block;
  position: relative;
  ${mq.pc} {
    &:nth-of-type(2n - 1) {
      border-right: solid 1px ${green02};
    }
    &:nth-of-type(n + 3) {
      border-top: solid 1px ${green02};
    }
    &:hover {
      & > div {
        & > span {
          color: ${green01};
        }
      }
    }
  }
  ${mq.sp} {
    &:not(:last-of-type) {
      border-bottom: solid 1px ${green02};
    }
  }
  & > div {
    display: flex;
    height: 120px;
    align-items: center;
    ${mq.sp} {
      height: 90px;
    }
    justify-content: space-between;
    & > span {
      display: block;
      ${text('18px', 24 / 18)}
      font-feature-settings: "palt";
      flex: 1 0 auto;
      transition: color ${fastDurationTime} ease;
      ${mq.spMin} {
        font-size: 16px;
      }
    }
  }
  svg {
    display: inline-block;
    width: 8px;
    height: 15px;
    margin-right: 24px;
    transform: rotate(180deg);
    ${mq.sp} {
      margin-right: 12px;
      width: 5px;
      height: 9px;
    }
  }
`);
const Thumb = styled.div`
  width: 120px;
  height: 100%;
  margin-right: 40px;
  ${mq.sp} {
    width: 90px;
    margin-right: 20px;
  }
  overflow: hidden;
  > div {
    backface-visibility: hidden;
    transition: transform ${baseDurationTime} ease-out;
    a:hover & {
      transform: scale(1.03);
    }
  }
`;

export default class InnerLink extends React.Component {
  render() {
    return (
      <Container to={this.props.to} current={this.props.isCurrent}>
        <div>
          <Thumb>
            <Image filename={this.props.thumb}></Image>
          </Thumb>
          <span>{this.props.children}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="4.407" height="8.44" viewBox="0 0 4.407 8.44">
            <path d="M4.907 8.22l-4-4 4-4" fill="none" stroke="#00ab84"/>
          </svg>
        </div>
      </Container>
    );
  }
}
